
import { useState } from 'react'
import { Link } from "react-router-dom"

export default function MobileMenu() {
	const [isAccordion, setIsAccordion] = useState(1)

	const handleAccordion = (key) => {
		setIsAccordion(prevState => prevState === key ? null : key)
	}
	return <>
		<div className="mobile-menu fix mb-3 mean-container">
			<div className="mean-bar">
				<Link to="/#nav" className="meanmenu-reveal" style={{ right: 0, left: 'auto', display: 'inline' }}>
					<span>
						<span>
							<span />
						</span>
					</span>
				</Link>
				<nav className="mean-nav">
					<ul>


						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/about">About Us</Link>
						</li>

						<li className="has-dropdown">
							<Link to="/">
								Products
								<i className="fa-regular fa-angle-down" />
							</Link>
							<ul className="submenu" style={{ display: `${isAccordion == 3 ? "block" : "none"}` }}>
								<li>
									<Link to="/Wpc-Doors">
										WPC Doors
									</Link>
								</li>
								<li>
									<Link to="/Wpc-Door-Frames">
										WPC Door Frames
									</Link>
								</li>
								<li>
									<Link to="/Wpc-Foam-Board">
										WPC Foam Board
									</Link>
								</li>
								<li>
									<Link to="/Wpc-UV-Digital-Series">
										WPC UV Digital Series
									</Link>
								</li>
								<li>
									<Link to="/Wpc-Printed-Doors">
										WPC Printed Doors
									</Link>
								</li>
								<li>
									<Link to="/Decorative-Doors">
										Decorative Doors
									</Link>
								</li>
							</ul>
							<a className="mean-expand" onClick={() => handleAccordion(3)} style={{ fontSize: 18 }}>
								<i className="fa-regular fa-angle-down" /></a>
						</li>
						<li>
							<Link to="/dealers-and-distribution">Dealership</Link>
						</li>
						<li>
							{/* <Link to="/DealersAndDistribution">Partner with V-Make</Link> */}
							<Link to="/Sustainability">Sustainability</Link>
						</li>




						<li>
							<Link to="/blogs">

								Blog
								<i className="fa-regular fa-plus" />
							</Link>


						</li>
						<li className="mean-last">
							<Link to="/contact">Contact Us</Link>
						</li>
					</ul>
				</nav></div></div>

	</>
}
